import { Alert, Button, Card, Checkbox, Space, Typography } from "antd";
import {
  QueryClient,
  useMutation,
  useQuery,
  useQueryClient,
} from "react-query";
import { useHistory } from "react-router-dom";
import axiosInstance from "../../config/axios-instance";
import useWindowWidth from "../../config/useWindowWidth";
import LazyImg from "../Library/LazyImage";
import watermak from "../../img/watermark.png";
import placeholder_jeans from "../../img/placeholder_jeans.svg";
import { useState } from "react";
import {
  deleteCustomizedProduct,
  orderNewCustomizedProduct,
} from "../../actions/order-actions/services";

const { Meta } = Card;
const { Title } = Typography;

export default function MyCustomizedProducts() {
  const [productsToOrder, setProductsToOrder] = useState([]);

  const getMyCustomizedProducts = async () => {
    let token = localStorage.getItem("token");

    return axiosInstance({
      url: "/customized_products/getdraft",
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
  };

  const { data: customized_products, isLoading } = useQuery(
    "my-customized",
    getMyCustomizedProducts
  );

  const queryClient = useQueryClient();

  const { mutateAsync: orderNow, isLoading: orderLoading } = useMutation(
    orderNewCustomizedProduct,
    {
      onSuccess: () => {
        queryClient.invalidateQueries("my-customized");
        setProductsToOrder([]);
      },
    }
  );

  const { mutateAsync: deleteProducts, isLoading: deleteLoading } = useMutation(
    deleteCustomizedProduct,
    {
      onSuccess: () => {
        queryClient.invalidateQueries("my-customized");
        setProductsToOrder([]);
      },
    }
  );

  return (
    <div style={{ padding: "20px", paddingBottom: "50px" }}>
      <div>
        <Title level={2} style={{ color: "#00468c", marginBottom: "0px" }}>
          My customized products
        </Title>
        <p style={{ opacity: 0.8, marginBottom: "20px" }}>
          To order or delete one or more product, please select those you want.
        </p>
        {isLoading ? (
          <p>Loading...</p>
        ) : (
          <div className="products-grid">
            {customized_products?.data.map((el: any, i: number) => (
              <div key={el.id}>
                <CustomizedCard
                  product={{
                    front: el.product_front_image,
                    back: el.product_back_image,
                    name: el.product_name,
                    code: el.product_code,
                    id: el.id,
                  }}
                  setProductsToOrder={setProductsToOrder}
                  productsToOrder={productsToOrder}
                />
              </div>
            ))}
          </div>
        )}
      </div>
      {productsToOrder.length > 0 && (
        <Alert
          message={`${productsToOrder.length} Product(s) selected`}
          type="info"
          style={{
            position: "fixed",
            left: "50%",
            // top: "100%",
            bottom: "0px",
            width: "30vw",
            borderRadius: "8px",
            border: "2px solid #809ec2",
            color: "#00468c",
            backgroundColor: "#f4f7ff",
            minWidth: "400px",
            transform: "translate(-50%,-50%)",
            zIndex: 20,
          }}
          action={
            <Space direction="horizontal">
              <Button
                size="middle"
                type="ghost"
                style={{
                  color: "#00468c",
                  borderColor: "#00468c",
                  borderRadius: "5px",
                }}
                onClick={() => deleteProducts(productsToOrder)}
                loading={deleteLoading}
              >
                Delete
              </Button>
              <Button
                size="middle"
                type="primary"
                style={{
                  background: "#00468c",
                  borderColor: "#00468c",
                  borderRadius: "5px",
                }}
                onClick={() => orderNow(productsToOrder)}
                loading={orderLoading}
              >
                Order now
              </Button>
            </Space>
          }
          closable
          onClose={() => setProductsToOrder([])}
        />
      )}
    </div>
  );
}

const CustomizedCard = ({
  product,
  setProductsToOrder,
  productsToOrder,
}: any) => {
  const width = useWindowWidth();
  const history = useHistory();

  const toggle = () => {
    const id = product.id;
    const isExist = productsToOrder.find((el: any) => el === id);

    let updatedList = [...productsToOrder];
    if (!isExist) {
      updatedList = [...productsToOrder, id];
    } else {
      updatedList.splice(productsToOrder.indexOf(id), 1);
    }
    setProductsToOrder(updatedList);
  };

  return (
    <Card
      style={{
        width: width < 1200 ? "100%" : "14rem",
        // padding: 15,
      }}
      bordered={true}
      // bodyStyle={{ padding: "0px" }}
      className="grid-item-product"
      cover={
        <div className={`product_item_new mb-2`}>
          <LazyImg
            alt={product.name}
            style={{
              position: "absolute",
              zIndex: 2,
              opacity: 0.2,
              objectFit: "contain",
              width: "100%",
              height: "260px",
            }}
            src={watermak}
            thumb={watermak}
          />
          <LazyImg
            className="img-front"
            alt={product?.name}
            style={{
              objectFit: "contain",
              width: "100%",
              height: "260px",
            }}
            src={
              product?.front
                ? process.env.REACT_APP_STORAGE_URL + product?.front
                : placeholder_jeans
            }
            thumb={
              product?.front
                ? process.env.REACT_APP_STORAGE_URL + product?.front
                : placeholder_jeans
            }
          />
          <LazyImg
            style={{ height: "260px", objectFit: "contain" }}
            className="img-back"
            alt={product?.name}
            src={
              product?.back
                ? process.env.REACT_APP_STORAGE_URL + product?.back
                : placeholder_jeans
            }
            thumb={
              product?.back
                ? process.env.REACT_APP_STORAGE_URL + product?.back
                : placeholder_jeans
            }
          />
        </div>
      }
    >
      <Meta
        description={
          <div className="d-flex mt-2 justify-content-between">
            <div className="labels_list">
              <div
                /*     onClick={() =>
                  history.push(`/customization/edit/${product.id}`)
                } */
                style={{ cursor: "pointer" }}
              >
                <h4 className="h4_medium mb-0" style={{ fontSize: "1rem" }}>
                  {product?.code}
                </h4>
                <h4
                  className="h4_medium"
                  style={{ fontWeight: 400, fontSize: "1rem" }}
                >
                  {product?.name}
                </h4>
              </div>
            </div>
            <div className="align-self-center">
              <Checkbox
                onChange={toggle}
                checked={productsToOrder.includes(product.id)}
              />
            </div>
          </div>
        }
      />
    </Card>
  );
};
